import style from './appItemsView.scss';

export default function ($rootScope, $scope, $stateParams, $http, $uibModal, $state, $q, $cookies, CONFIG, contentTypes) {
    'ngInject';
    $scope.style = style;

    console.log('contentTypes', contentTypes);

    let contentType = $stateParams.contentType;
    let contentTypeId = contentType.sys.id;
    let page = $stateParams.page || 1;
    let paginationResultsPerPage = CONFIG.paginationResultsPerPage;
    let T = $scope.$root.T;
    let labelPlural = contentType.name;
    let regionId = !!$cookies.get('region') ? JSON.parse($cookies.get('region')).sys.id : null;
    let search = $stateParams.search || null;

    let config = {
        errorMessage: T.HTTP_GET_ERROR_NOTIFICATION + labelPlural
    };

    $rootScope.$broadcast('selectionMenu', {context: 'article'});

    let endpoint = `entries?content_type=${contentTypeId}&order=-sys.createdAt&sys.type[ne]=${(new Date()).valueOf()}`;
    endpoint += `&fields.region.sys.id=${regionId}`;
    endpoint += `&skip=${paginationResultsPerPage * (page - 1)}&limit=${paginationResultsPerPage}`;
    $scope.isProgress = true;
    $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint}`, config).then(data => {
        $scope.isProgress = false;
        if (data.data.items.length > 0) {
            $state.go('^.edit',({id: _.first(data.data.items).sys.id, page: 1, search: search}));
        }
    }, (error) => { });
}



// WEBPACK FOOTER //
// ./src/app/views/app.item/appItemsListCtrl.js